import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ModalitiesServices from "./modalities.services";

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

export const getModalities = filters => async (dispatch) => {
    try {
        dispatch({
            type: actions.LOADER_MODALITIES,
            payload: true,
        });
        const resp = await ModalitiesServices.getModalities(filters);
        dispatch({
            type: actions.GET_MODALITIES,
            payload: resp.data, // agregar .data
        });
        dispatch({
            type: actions.MODALITIES_FAIL,
            payload: null,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MODALITIES_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MODALITIES,
            payload: false,
        });
    }
}

export const deleteModalities = (id, index) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_MODALITIES,
            payload: true,
        });
        await ModalitiesServices.deleteModalities(id);
        const { data, count } = getState().modalities.modalities;
        let _data = data.slice();
        _data.splice(index, 1);
        dispatch({
            type: actions.GET_MODALITIES,
            payload: {
                data: _data,
                count: count - 1
            },
        });
        dispatch({
            type: actions.MODALITIES_FAIL,
            payload: '',
        });
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MODALITIES_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MODALITIES,
            payload: false,
        });
    }
}

export const editModalities = (req, index, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_MODALITIES,
            payload: true,
        });
        const resp = await ModalitiesServices.editModalities(req.id, req);
        const { data, count } = getState().modalities.modalities;
        let _data = data.slice();
        _data[index] = resp.data;
        dispatch({
            type: actions.GET_MODALITIES,
            payload: {
                data: _data,
                count: count,
            },
        });
        dispatch({
            type: actions.FORM_MODALITIES_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });

    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.MODALITIES_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_MODALITIES,
            payload: false,
        });
    }
}

export const saveModalities = (req, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.SAVE_LOADER_MODALITIES,
            payload: true,
        });
        const resp = await ModalitiesServices.saveModalities(req);
        const { data, count } = getState().modalities.modalities;
        dispatch({
            type: actions.GET_MODALITIES,
            payload: {
                count: count + 1,
                data: [...data, resp.data]
            },
        });
        dispatch({
            type: actions.FORM_MODALITIES_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 500:
                        message = messages.errorMessage + " " + ex.response.statusText;
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = ex.response.data;
                        break;
                }
            } else {
                message =
                    ex.message === "Network Error" ? messages.networkError : ex.message;
            }
        } else {
            message =
                ex.message === "Network Error" ? messages.networkError : ex.message;
        }
        dispatch({
            type: actions.FORM_MODALITIES_FAIL,
            payload: message,
        });
    } finally {
        dispatch({
            type: actions.SAVE_LOADER_MODALITIES,
            payload: false,
        });
    }
};
